import * as React from 'react';
import { useState} from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from 'recharts';
import { CreateOverTime } from '../../_service/reports';
import { Button, Typography } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { report_response, create_over_time, report_historical_query, create_over_time_supplemental } from '../../_types/reports';
import { useContext } from 'react';
import { AuthContext } from '../../_auth/AuthContext';


interface Props {

};
const useStyles = makeStyles((theme: Theme) =>
createStyles({
    paging: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center'
    }

  })
);


const CreatesByDay: React.FC<Props> = (prop: Props) => {

    const { user } = useContext(AuthContext);
    const [data, setData] = useState<report_response<create_over_time, create_over_time_supplemental> | null>();
    const [displayData, setDisplayData] = useState<create_over_time[]>();
    const classes=useStyles();

    const defaultQuery = (): report_historical_query => {
        return {
            days: 30,
            offSetFromToday: 0,
            tzOffSet: (user.currentLocation) ? user.currentLocation.tz_offset : -240,
            locationId: (user.currentLocation) ? user.currentLocation.id : null,
            servicePlanId: null
        };
    };

    /*
        depending on direction, get lowest or highest (knowing that the highest is future, so will need to splice)
        only get from api the next block

    */
    const getMore = (increment: number) => {
      
        let direction = (increment < 0) ? -1 : 1;
        let query = defaultQuery();

        if (data) {

            
            if (increment === 0) {
                data.current = 0;
                setData(data);
                let displayData = data.data.filter((i) => {
                    return ((i.offSetFromToday > (data.current - 30)) && (i.offSetFromToday <= data.current));
                });
                setDisplayData(displayData);
            }

            // current position is the last element that is displayed (so there will alwasy be 30 prior)
            // on first call lowest will be -29, current will be 0, highest will be 0 
            // let current = data.current;
            let newCurrent = data.current + increment;
            let newMin = newCurrent - 29;

            if (newMin < data.lowest || newCurrent > data.highest) {
                //we need to get the next block
                query.offSetFromToday = (direction < 0) 
                    ? data.lowest - 1
                    : (data.highest) + increment
                query.days = Math.abs(increment);
          
                CreateOverTime(query).then((d) => mergeData(d, false));
            } else {
                //we must already have the data
                data.current += increment;
              
                setData(data);
                let displayData = data.data.filter((i) => {
                    return ((i.offSetFromToday > (data.current - 30)) && (i.offSetFromToday <= data.current));
                });
                setDisplayData(displayData);
            }
        }
    }



    /*
        if data is negative, prepend
        if data is positive, splice out last and append
    */
    const mergeData = (newData: report_response<create_over_time, create_over_time_supplemental>, reset: boolean) => {
        if (!reset && (data && newData)) {
    
            //if data is in negative range, we are moving backward
            if (newData.lowest < 0) {
                
          
                data.data = newData.data.concat(data.data);
    
                data.lowest = newData.lowest;
                data.current = data.lowest + 29;
            } else {
                //data.data.pop(); // pop off the future item
          
                data.data = data.data.concat(newData.data);
          
               
                data.highest = newData.highest;
                data.current = newData.highest;
            }
            setData(data);
            
            let displayData = data.data.filter((i) => {
                return ((i.offSetFromToday > (data.current - 30)) && (i.offSetFromToday <= data.current));
            });

            setDisplayData(displayData);

        } else {
         
            setData(newData);
            let displayData = newData.data.filter((i) => {
                return ((i.offSetFromToday > (newData.current - 30)) && (i.offSetFromToday <= newData.current));
            });
            setDisplayData(displayData);
            //supplemental
            // if (newData.supplemental.future_unfreeze) {
            //     setFutureUnfreeze(newData.supplemental?.future_unfreeze);
            // } else {
            //     setFutureUnfreeze(0);
            // }
            
        }
    }

    React.useEffect(() => {
     
        let newQuery = defaultQuery();
        
        //don't do any refresh if we haven't already gotten data.
        if (data) {
            setData(null);
            if (user.currentLocation) {
                
                newQuery.locationId = user.currentLocation.id;
                newQuery.tzOffSet = user.currentLocation.tz_offset;
       
                CreateOverTime(newQuery).then((d) => mergeData(d, true));
            } else {
               
                newQuery.tzOffSet = -240;
                newQuery.locationId = null;
          
                CreateOverTime(newQuery).then((d) => mergeData(d, true));
            }
        }

    }, [user]);

    const moveForward = ():boolean => {
        if (data) {
            return data.current >= 0;
        } else return false;
    }

    //load data on component load
    React.useEffect(() => {
      
        CreateOverTime(defaultQuery()).then((d) => mergeData(d, true));
    }, []);   

    if (data === undefined) {
        return (<div>Loading New Membership Report</div>);
    } else {

        return (
                <div>
                <Typography align="center" variant="h6">New Memberships</Typography>
                <ResponsiveContainer width="95%" height={300}>
                <LineChart
                    
                    
                    data={displayData}
                    margin={{
                    top: 5, right: 5, left: 5, bottom: 5,
                    }}
                    >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="period" />
                    <YAxis/>
                    <Tooltip />
                    <Legend />
                    <Line type="monotone" name="Total" dataKey="total_create" stroke="#8884d8" dot={false} activeDot={{ r: 8 }} />
                    <Line type="monotone" name="Active" dataKey="total_active" stroke="#82ca9d" dot={false}/>
                    <Line type="monotone" name="Unpaid" dataKey="total_unpaid" stroke="#3d34eb" dot={false}/>
                </LineChart>
                
                </ResponsiveContainer>

                <div className={classes.paging}>   
                <Button onClick={()=>getMore(-30)}>{"<< 30"}</Button>
                <Button onClick={()=>getMore(-10)}>{"<< 10"}</Button>
                <Button disabled={moveForward()} onClick={()=>getMore(0)}>{"Today"}</Button> 
                <Button disabled={moveForward()} onClick={()=>getMore(10)}>{">> 10"}</Button> 
                <Button disabled={moveForward()} onClick={()=>getMore(30)}>{">> 30"}</Button> 
                </div>
                </div>

                )
    }
}

export default CreatesByDay;